module.exports = __webpack_public_path__ + "../public/img/ylw_icoQuiz.4988bf3e.png";